module.exports = __webpack_public_path__ + "img/login-register.f71303dc.jpg";